import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { badgeVariants } from ".";
import { cn } from "@/lib/utils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Badge',
    props: {
        variant: {},
        class: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_unref(cn)(_unref(badgeVariants)({ variant: _ctx.variant }), props.class))
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
